import React from 'react';
import { currentLibrarySelector } from '../selectors/LibrarySelector';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import * as BorrowingActions from '../actions/BorrowingActions';
import { currentAccountSelector, currentUserSelector } from '../selectors/AuthSelector';
import * as InterlibraryLoansActions from '../actions/InterlibraryLoansActions';
import { bindActionCreators } from 'redux';
import NotFound from '@bibliocommons/not-found';
import InterlibraryLoans from '../components/borrowing/interlibraryLoans/InterlibraryLoans';
import DocumentHeadContainer from './DocumentHeadContainer';
import { getInterlibaryLoans, getInterlibaryLoansStatus } from '../selectors/InterlibraryLoansSelector';
import BasePageContainer from './BasePageContainer';

export class InterlibraryLoansContainer extends BasePageContainer {

  static fetchInitialData(params, query, store) {
    const account = currentAccountSelector(store.getState());
    const accountId = account && account.get('id');

    return [
      store.dispatch(BorrowingActions.fetchSummaries({ accountId })),
      store.dispatch(InterlibraryLoansActions.fetchInterlibraryLoans({ accountId, ...params, ...query }))
    ];
  }

  static getBackToTitleKey() {
    return 'interlibrary_loans';
  }

  componentDidMount() {
    super.componentDidMount();

    const { accountId } = this.props;
    this.props.InterlibraryLoansActions.fetchInterlibraryLoans({ accountId });
  }

  render() {
    const pageTitle = this.props.intl.formatMessage({ id: 'section_title_interlibraryloans' });


    if (!this.props.interlibraryLoansSupported) {
      return <NotFound />;
    }

    return (
      <div>
        <DocumentHeadContainer pageTitle={pageTitle} />
        <InterlibraryLoans {...this.props} />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  InterlibraryLoansActions: bindActionCreators(InterlibraryLoansActions, dispatch)
});

const mapStateToProps = (state) => {
  const library = currentLibrarySelector(state);
  const interlibraryLoansSupported = library.get('illRequests');
  const user = currentUserSelector(state);
  const accountId = currentAccountSelector(state).get('id');
  const interlibraryLoansStatus = getInterlibaryLoansStatus(state);
  const items = getInterlibaryLoans(state);
  return {
    intl: intlShape,
    user,
    accountId,
    items,
    interlibraryLoansSupported,
    isFetching: interlibraryLoansStatus.get('isFetching')
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(InterlibraryLoansContainer));



// WEBPACK FOOTER //
// ./app/containers/InterlibraryLoansContainer.jsx